module.exports = __webpack_public_path__ + "static/card2-46bf004caf5ee784bbcbed9277cc61ec.svg";